import { useEffect, useRef } from "react";
import ReactHtmlParser from "react-html-parser";
import ButtonComp from "./ButtonComp";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";

const ExamSkillsSection = ({
  contentSection,
  description,
  ctaText,
  onCtaClick,
  cards = [],
  bottomText,
  customStyle = false,
  sliders=3.5,
  showInSlider=true
}) => {
  
  return (
    <section className="exam-section py-5">
      <div className="custom-container">
        {/* Top Row */}
        <div className="row align-items-center mb-5">
          {/* Left */}
          <div className="col-lg-6">
            {/* <h2 className="top-section-text FS40FW600">
              {title} <span className="text-success">{highlight}{" "}</span>{" "+subtitle ? subtitle : "" }
            </h2> */}
            {contentSection && contentSection()}
          </div>

          {/* Right */}
          <div className={`col-lg-6 ${description ? "text-start" : "text-start text-lg-end"} mt-3 mt-lg-0`}>
            {description && 
                <p className="text-muted FS16FW500 fw-300 mb-3">
                {typeof description === "string"
                    ? ReactHtmlParser(description)
                    : description}
                </p>
            }

            <ButtonComp link={onCtaClick} btnText={ctaText}/>
          </div>
        </div>

        {/* Cards : "row flex-nowrap overflow-auto g-4 scroll-row p-2"*/}
        {(cards.length <= 3 || showInSlider) ? (
          <div
            className={`row g-4 ${
              customStyle ? "flex-nowrap overflow-auto scroll-row" : ""
            }`}
          >
            {cards.map((card, index) => {
              const isLastRowTwoCards =
                cards.length % 3 === 2 && index >= cards.length - 2;

              return (
                <div
                  key={index}
                  className={
                    isLastRowTwoCards
                      ? "col-md-6"
                      : "col-md-6 col-lg-4"
                  }
                >
                  <SkillCard card={card} index={index} />
                </div>
              );
            })}
          </div>
        ):(
           <Swiper
              modules={[FreeMode]}
              spaceBetween={16}
              slidesPerView={sliders}
              grabCursor={true}
              freeMode={true}
              breakpoints={{
                1400: { slidesPerView: sliders },
                1200: { slidesPerView: 3.5 },
                992: { slidesPerView: 2.8 },
                768: { slidesPerView: 2.2 },
                576: { slidesPerView: 1.5 },
                0: { slidesPerView: 1.2 },
              }}
              className="py-2"
            >
              {cards.map((card, index) => (
                <SwiperSlide key={card.id || index}>
                  <div className='col-12 d-flex lifestyle-card' >
                  <SkillCard card={card} index={index} />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
           )}
        {/* <div className={`row  g-4  ${customStyle ? "flex-nowrap overflow-auto scroll-row" : ""}`} ref={scrollRef}>
          {cards.map((card, index) => (
            <div className="col-md-6 col-lg-4" key={index}>
              <SkillCard card={card} />
            </div>
          ))}
        </div> */}

        {/* Bottom Text */}
        <p className="text-center mt-5 text-muted">
            {bottomText && bottomText}
        </p>
      </div>
    </section>
  );
};

export default ExamSkillsSection;

const SkillCard = ({ card }) => {
  return (
    <div className="skill-card h-100 p-4">
      {/* Icon + Title */}
      <div className="d-flex align-items-center mb-3">
        <div className="me-3 col-auto">
          <img src={card.icon} alt="icon" />
        </div>
        <h6 className="mb-0 plus-sans FS24FW500 fw-700 to-unset-transform col-9">{card.title}</h6>
      </div>

      {/* Content */}
      <div className="quote-para FS16FW500" style={{lineHeight:'28px'}}>
        {typeof card.content === "string" ? ReactHtmlParser(card.content) : card.content}
      </div>
    </div>
  );
};
